import React from 'react'
import DeathClaimDetails from '../DeathClaimDetails/DeathClaimDetails'

export default function AdditionalDetails(props) {

  if(props.hasDeathBenefit){
    return <DeathClaimDetails {...props} />
  }
}
